import { StripePricingIds } from "@Enums";
import cards from "./cards";
import { account } from "./en.account";
import { activity } from "./en.activity";
import { admin } from "./en.admin";
import { api } from "./en.api";
import { appBar } from "./en.app-bar";
import { builder } from "./en.builder";
import { bybcat } from "./en.bybcat";
import { challenges } from "./en.challenges";
import { demo } from "./en.demo";
import { dictionary } from "./en.dictionary";
import errors from "./en.errors";
import { leaderboard } from "./en.leaderboard";
import { members } from "./en.members";
import { metrics } from "./en.metrics";
import { navBar } from "./en.nav-bar";
import { notifications } from "./en.notifications";
import paths from "./en.path";
import { playlists } from "./en.playlists";
import { profile } from "./en.profile";
import { progress } from "./en.progress";
import { purchaseFlow } from "./en.purchase-flow";
import { releaseNotes } from "./en.release-notes";
import { roles } from "./en.roles";
import { sessionResults } from "./en.session-results";
import tags from "./en.tags";
import { teamManagement } from "./en.team-management";
import { tools } from "./en.tools";
import metricTooltips from "./en.tooltips";
import { video } from "./en.video";
import { welcome } from "./en.welcome";
import { mobileCommon } from "./mobile/en.mobile.common";
import routes from "./routes";
import { about } from "./settings/en.about";
import { help } from "./settings/en.help";
import { privacy } from "./settings/en.privacy";
import { security } from "./settings/en.security";
import { subscriptionManagement } from "./subscription-management";
import { paymentMethod } from "./subscription-management/en.payment-method";
import { career } from "./VR/en.vr.career";
import { coach } from "./VR/en.vr.coach";
import { common } from "./VR/en.vr.common";
import { guides } from "./VR/en.vr.guides";
import { header } from "./VR/en.vr.header";
import { vrHome } from "./VR/en.vr.home";
import { matchPlay } from "./VR/en.vr.match-play";
import { positionSelection } from "./VR/en.vr.position-selection";
import { practice } from "./VR/en.vr.practice";
import { settings } from "./VR/en.vr.settings";
import { trainingPlans } from "./VR/en.vr.training-plans";
import { byb360 } from "./web-portal/en.byb360";
import { portalHome } from "./web-portal/en.portal.home";
import { challengeEditor } from "./web-portal/super-admin/en.challenge-editor";

const en = {
  ...routes,
  ...cards,
  ...errors,
  ...api,
  ...purchaseFlow,
  ...career,
  ...coach,
  ...common,
  ...video,
  ...bybcat,
  ...challenges,
  ...paymentMethod,
  ...appBar,
  ...navBar,
  ...profile,
  ...teamManagement,
  ...notifications,
  ...roles,
  ...tools,
  ...metrics,
  ...settings,
  ...header,
  ...progress,
  ...dictionary,
  ...sessionResults,
  ...guides,
  ...tags,
  ...matchPlay,
  ...vrHome,
  ...metricTooltips,
  ...practice,
  ...trainingPlans,
  ...security,
  ...subscriptionManagement,
  ...account,
  ...byb360,
  ...welcome,
  ...activity,
  ...paths,
  ...releaseNotes,
  ...members,
  ...playlists,
  ...admin,
  ...challengeEditor,
  ...leaderboard,
  ...about,
  ...help,
  ...privacy,
  ...positionSelection,
  ...mobileCommon,
  ...demo,
  ...builder,
  ...portalHome,

  /**
   * Misc
   */
  "device.not.supported": "This device is not supported",
  version: "Version",

  /* Network Errors */
  "error.disconnected.title": "Connection Error",
  "error.disconnected.message": "Internet appears to be disconnected",
  "error.network.title": "Network Error",
  "error.network.message": "A network error occurred, please check your internet connection and try again",
  /* Auth errors */
  "auth/email-already-exists": "User Already Exists",
  "auth.user-not-found": "Unknown Email address, please try again",
  "auth.wrong-password": "Incorrect password, please try again",
  "auth.email-already-exists": "An account with that Email already exists",
  "auth.try-signing-in": "try signing in",
  "auth.too-many-requests": "Too many failed attempts, please try again later or reset your password",
  "auth.invalid-email": "Invalid Email address, please check you've entered it correctly",
  "auth.missing-email": "Please enter an Email address",
  "error.network-failure": "Could not connect to server, please try again",
  "error.generic": "An error occurred, please try again",
  // Server Errors
  internal: "Problem connecting to server",
  "error.notresponding.title": "Network Error",
  "error.notresponding.message": "Server is not responding at the moment",
  "error.Internal.title": "Network Error",
  "error.Internal.message": "Server",
  // Validation Errors
  "auth/invalid-email": "Invalid Email",

  /* eslint-disable */
  'An internal error has occurred. Raw server response: "{"error":{"code":400,"message":"TOO_MANY_ATTEMPTS_TRY_LATER","errors":[{"message":"TOO_MANY_ATTEMPTS_TRY_LATER","domain":"global","reason":"invalid"}]}}""':
    "A verification email has already been sent, please wait a couple minutes before requesting another.",
  /* eslint-enable */

  /**
   * General UI
   */
  "text.league": "League",
  "text.division": "Division",
  "button.retry": "Retry",
  "button.cancel": "Cancel",
  "button.save": "Save",
  "button.start": "start",
  "button.apply": "Apply",
  "button.submit": "Submit",
  "button.close": "Close",
  "button.sign.out": "Sign Out",
  "button.sign.in": "Sign In",
  "button.register": "Register",
  "button.done": "Done",
  "button.continue": "Continue",
  "button.forgot.password": "Forgot Password",
  "button.yes": "Yes",
  "button.no": "No",
  "button.back": "Back",
  "button.confirm": "Confirm",
  "button.exit.app": "Exit App",
  "button.purchase": "Purchase",
  "button.renew.access": "Manage Access",
  "button.create.account": "Create Account",
  "button.not.a.user": "Need to sign up?",
  "button.refresh.subscriptions": "Refresh Account",
  "button.change.account": "Change Account",
  "button.update": "Update",
  "button.new.playlist": "New Playlist",
  "button.save-changes": "Save Changes",
  "button.skip": "Skip",
  "button.next-challenge": "Next Challenge",
  "button.view.session": "View Session",
  "button.view.profile": "View profile",

  /**
   * Titles
   */
  "title.create.account": "Create Account",
  "title.choose.plan": "Choose Your Plan",
  "title.teams": "TEAMS",
  "title.playlists": "PLAYLISTS",
  "title.filter-by": "Filter by",
  "title.filter-by-metric": "Filter",
  "title.filter-by-period": "Filter by period",
  "title.filter-by-result": "Filter by result",
  "title.period": "Period",
  "title.your-metrics": "Your metrics",
  "title.you": "You",
  "title.your-rank": "Your rank",
  "title.leaderboard": "Players",

  "title.practice": "Practice",

  "title.progress-overview": "Progress Overview",
  "title.session-results": "Session Results",

  /**
   * Subtitles
   */
  "subtitle.filters.general": "General",
  "subtitle.filters.metrics": "Metrics",

  /**
   * Labels
   */
  "label.role": "Role",
  "label.joined": "Joined",
  "label.actions": "Actions",
  "label.authorization": "Authorization",
  "label.member": "Member",
  "label.manage": "Manage",
  "label.add_member": "Add Member",
  "label.products": "Products",
  "label.add_product": "Add Product",
  "label.status": "Status",
  "label.active": "Active",
  "label.inactive": "Inactive",
  "label.paused": "Paused",
  "label.start_date": "Start Date",
  "label.end_date": "End Date",
  "label.resume": "Resume",
  "label.pause": "Pause",
  "label.add": "Add",
  "label.product": "Product",
  "label.search": "Search",
  "label.created": "Created",
  "label.business": "Business",
  "label.remove": "Remove",
  "label.app-version": "App Version",
  "label.clear": "Clear",
  "label.play": "Play",
  "label.share": "share",
  "label.delete": "delete",
  "label.save": "Save",
  "label.cancel": "Cancel",
  "label.create": "Create",
  "label.new": "New",
  "label.edit": "Edit",
  "label.age": "Age",
  "label.email": "Email Address",
  "label.password": "Password",
  "label.confirm.password": "Confirm",
  "label.name": "Name",
  "label.first.name": "First Name",
  "label.last.name": "Last Name",
  "label.date.of.birth": "Date of Birth *",
  "label.gender": "Gender",
  "label.currency.symbol": "$",
  "label.scan_frequency": "Scan Rate",
  "label.scan_timing": "Scan Timing",
  "label.awareness": "Awareness",
  "label.decision": "Decision",
  "label.critical_scan": "Critical Scan",
  "label.target": "Target",
  "label.members": "Members",
  "label.members.count": "Members ({{ count }})",
  "label.playlist": "Playlist",
  "label.duration": "Duration",
  "label.seconds": "Seconds",
  "label.session": "Session",
  "label.sessions": "Sessions",
  "label.scenarios": "Scenarios",
  "label.set": "Set",
  "label.sets": "Sets",
  "label.focus": "Focus",
  "label.points.short": "pts",
  "label.rating-points": "Rating Points",
  "label.session-info": "Session Info",
  "label.on": "On",
  "label.off": "Off",
  "label.tests": "Tests",
  "label.random": "Random",
  "label.max": "Max",
  "label.results": "Results",
  "label.result": "Result",
  "label.replays": "Replays",
  "label.downloading": "Downloading",
  "label.details": "Details",

  "label.game-speed": "Game Speed",
  "label.scenario-count": "Scenario Count",

  "label.game-mode.scenario": "Scenario",
  "label.game-mode.match_play": "Matchplay",

  "label.no.teams": "No teams",

  "label.session-type.progression_session": "Career",
  "label.session-type.practise_session": "Practice",
  "label.session-type.challenge_session": "Challenge",
  "label.session-type.private_session": "Private Training",
  "label.session-type.match_play": "Match Play",
  "label.session-type.playlist_session": "Playlist",

  "label.filters": "Filters",

  "label.metric-type.byb_iq": "BYB IQ",
  "label.metric-type.awareness": "Awareness",
  "label.metric-type.decision": "Decision",
  "label.metric-type.critical_scan": "Critical Scan",
  "label.metric-type.scan_timing": "Scan Timing",
  "label.metric-type.scan_frequency": "Scan Rate",
  "label.metric-type.time_trained": "Time Trained",
  "label.metric-type.gameplay_duration": "Gameplay Duration",
  "label.metric-type.passes_score": "Decision",
  "label.metric-type.scan_rate": "Scan Rate",
  "label.metric-type.critical_scans": "Critical Scan",
  "label.metric-type.awareness_score": "Awareness",
  "label.metric-type.total_score": "Total Score",

  "label.overall-metric": "BYB IQ",

  "label.progress.year": "Yearly Progress",
  "label.progress.quarter": "Quarterly Progress",
  "label.progress.month": "Monthly Progress",
  "label.progress.week": "Weekly Progress",

  "label.scenario-replay": "Replay",
  "label.available": "Available",
  "label.expired": "Expired",
  "label.currently-unavailable": "Currently Unavailable",
  "label.not-available": "Not Available",

  "label.personal-details": "Personal details",
  "label.league": "League",
  "label.division": "Division",

  "label.global-rank": "Global Rank",
  "label.user-rating": "User Rating",
  "label.rating": "Rating",
  "label.level": "Level",

  "label.league.bootcamp": "Bootcamp",
  "label.league.bronze": "Bronze League",
  "label.league.silver": "Silver League",
  "label.league.gold": "Gold League",
  "label.league.platinum": "Platinum League",
  "label.league.champions": "Champions League",

  "label.overall.session.score": "Overall session score",
  "label.top.results": "Your top results",
  "label.replay": "Replay",
  "label.comparison": "Comparison",
  "label.admin.performance-report.title": "Performance Report",
  "button.admin.performance-report.download": "Get Report",
  "label.admin.performance-report.custom-dates.title": "Custom Dates",
  "label.admin.performance-report.custom-dates.description": "Download a report on team members' performance between the following dates.",
  "label.admin.performance-report.date-range.all-time.title": "All Time",
  "label.admin.performance-report.date-range.all-time.description":
    "Download a report on team members' performance from the beginning of time until now.",

  "label.period.this_week": "This Week",
  "label.period.last_week": "Last Week",
  "label.period.this_month": "This Month",
  "label.period.last_month": "Last Month",
  "label.period.this_year": "This Year",
  "label.period.last_year": "Last Year",
  "label.period.weekly": "Weekly",
  "label.period.monthly": "Monthly",
  "label.period.yearly": "Yearly",
  "label.period.all_time": "All Time",

  "leaderboard.table-rank": "Leaderboard · {{ rank }}",
  "leaderboard.user-rank-not-available": "You're not ranked yet",
  "leaderboard.this-week-no-data": "You can take this weeks top ranking by training now!",
  "leaderboard.no-data": "No rankings available for the selected period",

  "leaderboard.join.title": "Join the leaderboard and compete with other players around the world",
  "leaderboard.join.button": "Join now",

  /**
   * Dialogs
   */
  "dialog.delete.playlist.title": "Confirm Playlist Deletion",
  "dialog.delete.playlist.message": "will be deleted. This actions cannot be undone.",

  "dialog.confirm.playlist.start.title": "Start Custom Session",
  "dialog.confirm.playlist.start.message": "Press start to begin a custom training session for playlist",

  "dialog.test.scenario.title": "Preview Scenario",
  "dialog.test.scenario.message": "Press start to preview scenario",

  /**
   * Tool Tips
   */
  "tip.password.requirements": "At least 8 characters",

  /**
   * Landing Page
   */
  "button.already.a.user": "Already a user?",

  /**
   * Subscriptions
   */
  "subscription.byb.plus.title": "PLUS",
  "subscription.byb.plus.subtitle": "Prepaid Access",

  /**
   * Sign Up Packages
   */
  // Annual
  "signup.package.annual.pricing.id": StripePricingIds.AllACCESS_ANNUAL,
  "signup.package.annual.title": "Yearly",
  "signup.package.annual.subtitle": "3 profiles included",
  "signup.package.annual.description": "Billed ${{ price }} annually",
  "signup.package.annual.savings": "Save $120",
  "signup.package.annual.cta": "Limited offer - 34% off",
  "signup.package.annual.tag": "Best Value",
  "signup.package.annual.period": "/mo.",
  "signup.package.annual.name": "BYB Full Access Annually",
  "signup.package.annual.membership": "Yearly - ${{ price }}/mo.",
  "signup.package.annual.billed": "Billed yearly",
  // Monthly
  "signup.package.monthly.pricing.id": StripePricingIds.AllACCESS_MONTHLY,
  "signup.package.monthly.title": "Base Monthly",
  "signup.package.monthly.subtitle": "3 profiles included",
  "signup.package.monthly.description": "Billed ${{ price }} monthly",
  "signup.package.monthly.savings": "Save $???",
  "signup.package.monthly.cta": "Limited offer - 20% off",
  "signup.package.monthly.tag": "Best Value",
  "signup.package.monthly.period": "/mo.",
  "signup.package.monthly.name": "BYB Full Access Monthly",
  "signup.package.monthly.membership": "Base Monthly - ${{ price }}/mo.",
  "signup.package.monthly.billed": "Billed monthly",
  // Multi-seat monthly
  "signup.package.multiseat.monthly.title": "Monthly",
  "signup.package.multiseat.monthly.subtitle": "Minimum 3 profiles included",
  "signup.package.multiseat.monthly.name": "BYB Full Access Monthly ({{ seats }} profiles)",
  "signup.package.multiseat.monthly.membership": "Monthly - Starts at ${{ price }}/mo.",
  "signup.package.multiseat.monthly.period": "per month",
  "signup.feature.7.name.multiseat": "Option to add extra user profiles",
  // Multi-seat yearly
  "signup.package.multiseat.annual.title": "Annual",
  "signup.package.multiseat.annual.subtitle": "Minimum 3 profiles included",
  "signup.package.multiseat.annual.name": "BYB Full Access Yearly ({{ seats }} profiles)",
  "signup.package.multiseat.annual.membership": "Yearly - Starts at ${{ price }}/mo.",
  "signup.package.multiseat.annual.period": "per month",
  "signup.package.multiseat.annual.period.note": "${{ price }} billed yearly",

  "signup.features.title": "Includes",
  "signup.teams.description": "For organizations and teams seeking tailored solutions",
  "signup.teams.book.meeting": "Book A Meeting",

  /**
   * Settings
   */
  "settings.heading": "Settings",

  // Terms
  "signup.step.0.terms.heading": "I Accept Service Terms",
  "signup.step.0.terms.link.name": "Terms of Service",
  "signup.step.0.terms.link": "https://www.beyourbest.com/terms",
  "signup.step.0.privacy.link.name": "Privacy Policy",
  "signup.step.0.privacy.link": "https://www.beyourbest.com/privacy",
  "signup.step.0.terms.error": "Please accept service agreements",
  "signup.step.0.agree.terms": "By signing up you agree with our",
  "signup.step.0.and": "and",

  // Body text
  "signup.step.0.body": "Make sure you have an Oculus Quest VR headset that is setup and ready to go",
  "signup.step.0.link.text": "Get one here",
  "signup.step.0.link": "https://www.oculus.com/quest-2/",
  "signup.step.0.submit.button": "I have a headset",
  "signup.step.1.body": "",
  "signup.step.1.verified.body": "Account verified, please sign in to continue",

  // Email verify
  "signup.verify.email.heading": "Verify Account",
  "signup.verify.email.body": `A verification email has been sent to you with a link 
    you can use to continue the sign up process.`,
  "signin.verify.refresh": "Refresh",
  "signup.verify.link.resend": "Send new link",
  "signup.verify.link.sent": "Link sent",

  // Features
  "signup.feature.1.name": "VR & Mobile Apps",
  "signup.feature.2.name": "Advanced scanning training",
  "signup.feature.3.name": "Memory and awareness training",
  "signup.feature.4.name": "800+ moments from top leagues",
  "signup.feature.5.name": "Replay analysis & Stat Tracking",
  "signup.feature.6.name": "Stats tracking",
  "signup.feature.7.name": "3 user profiles",
  "signup.feature.8.name": "And more!",
  "signup.feature.9.name": "Play On Quest",
  "signup.feature.10.name": "Play On Pico VR",
  "signup.feature.11.name": "Mobile App (TBA)",
  "signup.feature.12.name": "Cross Platform Support",
  "signup.feature.13.name": "AI Matchplay (Beta)",

  // Verify Email Popup
  "signin.verify.email.heading": "Please verify your email address",
  "signin.verify.email.body.1": "You should have recieved an account verification email, please check your inbox.",
  "signin.verify.email.body.2": "If you have already verified your email or require a new verification email please use the refresh button below.",
  "signin.verify.email.button": "Resend Email",
  "signin.email.already.verified": "The Email for this user account has already been verified",

  /**
   * Oculus
   **/
  "oculus.not.entitled.heading": "Access Restricted",
  "oculus.not.entitled.body": "This Oculus user is not entitled to access this app",
  "oculus.init.error.heading": "Oculus platform error",
  "oculus.init.error.body": "A fatal error occurred when trying to connect to Oculus platform, this is not a problem with this app",
  "oculus.existing.account.header": "Do you have an existing Be Your Best account?",
  "oculus.existing.account.body": "You can either sign in with an existing account or create a new one",
  "oculus.existing.account.yes": "Sign In",
  "oculus.existing.account.no": "Create Account",
  "oculus.link.account.header": "Link App To Account",
  "oculus.link.account.body": "Do you want to link this app to your Be Your Best account?",

  /* Notifications */
  "notifications.no.content.title": "Subscription Problem Detected",
  "notifications.no.content.description":
    "There appears to be an issue with your subscription configuration, we will attempt to fix this automatically shortly. Please contact support@beyourbest.com if this error persists.",

  "notifications.access.expired.title": "Access Expired",
  "notifications.access.expired.unity.description":
    "Your Be Your Best access has expired. Please visit www.beyourbest.com to see our subscription plans.",
  "notifications.access.expired.web.description":
    "Your Be Your Best access has expired. Please continue by selecting one of our new group access plans.",
  "notifications.access.expired.not.linked.description":
    "Your Be Your Best PLUS access has expired. You must switch to your linked Meta/Oculus account to update you package.",

  /* Messages */
  "messages.no.purchase.appid.match.message":
    "Your Be Your Best account is not linked to the Quest profile you are currently using, to purchase access you must switch to the correct profile on your device.",

  "session.improvement.outcome.excellent": "Unbelievable improvement from your previous session",
  "session.improvement.outcome.great": "You did much better than your last session",
  "session.improvement.outcome.good": "You beat your previous scores",
  "session.improvement.outcome.average": "Similar performance to your last one",
  "session.improvement.outcome.below_average": "Your scores were lower compared to your last session",
  "session.improvement.outcome.poor": "You performed much worse than your last session",
  "session.improvement.outcome.bad": "This was too far below your previous session",

  "privacy.leaderboard.section.title": "Leaderboard Settings",
  "privacy.leaderboard.opt-in": "Join leaderboards",
  "privacy.leaderboard.opt-in.explanation": "Share your best scores with other players and see how you rank against them.",
  "privacy.leaderboard.anonymous": "Anonymous ranking",
  "privacy.leaderboard.anonymous.explanation": "Your name and avatar will not be shared with other players.",

  "privacy.profile.section.title": "Profile Settings",
  "privacy.admin-profile.opt-in": "Share data with admins",
  "privacy.admin-profile.explanation": "Share your profile & training data with admins of your private groups.",
  "privacy.admin-profile.note": "EG: Coaches, Trainers, Parents.",
  "privacy.group-profile.opt-in": "Share data with groups",
  "privacy.group-profile.explanation": "Share your profile & training data with players of your private groups.",
  "privacy.public-profile.opt-in": "Share profile with all players",
  "privacy.public-profile.explanation": "Make your profile visible to other players outside of your groups.",
  "privacy.public-profile.note": "(Note: This does not share your training data).",

  "privacy.push-notifications.opt-in": "Push Notifications",
  "privacy.push-notifications.explanation": "Receive notifications about your training progress and new features.",
  "privacy.push-notifications.note": "You can change this setting at any time in your profile settings.",

  "training.volume.section.title": "Audio Settings",
  "training.volume.master": "Master Volume",
  "training.volume.music": "Music Volume",
  "training.volume.voice": "Voice Volume",
  "training.volume.crowd": "Crowd Volume",
  "training.feedback.section.title": "In-Game Feedback Settings",
  "training.feedback.text.title": "Show text feedback for:",
  "training.feedback.text.critical": "Critical Scans",
  "training.feedback.text.decisions": "Decisions",
  "training.feedback.voice.title": "Give Voice feedback for:",
  "training.feedback.voice.scan-rate": "Scan Rate",
  "training.feedback.voice.scan-timing": "Scan Timing",
  "training.feedback.voice.critical": "Critical Scans",
  "training.feedback.voice.awareness": "Awareness Tests",
  "training.feedback.voice.decisions": "Decisions",
  "training.haptic.section.title": "Controller Vibration Settings",
  "training.haptic.strength": "Vibration Strength",

  "profile.leaderboard.title": "Leaderboard",
  "profile.join-leaderboard.cta": "See your rank",
  "profile.join-leaderboard.button": "Join leaderboard",

  "software-licenses": "Licenses",

  /* Survey Options */
  "survey.help_us.title": "Help us improve",
  "survey.help_us.description": "Where have you heard about Be Your Best? You can select more than one option.",
  "survey.help_us.friends": "Friends / Family",
  "survey.help_us.news": "Read about you",
  "survey.help_us.other": "Other",
};
export default en;
